module.exports = __webpack_public_path__ + "static/media/angle-left-white.dc1cfdae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/angle-left-white.svg
// module id = 468
// module chunks = 2